export function formatDisplayName(fullName: string, credentials?: string | null): string {
  if (!credentials?.trim()) return fullName;
  return `${fullName}, ${credentials.trim()}`;
}
